import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ToastService } from '../../../common-services/Toast/ToastService';
import { Result } from '../../../common-models/Result';
import { DanfePackingData } from '../../../models/DanfePackingData';
import { strings } from '../../../resources/strings';
import { ReportService } from '../../Reports/ReportService';
import { GetDanfePackingLabelInput } from './GetDanfePackingLabelInput';

export class GetDanfePackingLabelService extends HttpServiceBase {

  constructor(
    private report: ReportService,
    private toaster: ToastService,
    http?: any | null
  ) {
    super(http);
  }

  fileHandle = (input: GetDanfePackingLabelInput) => {
    this.http.postToDownloadFile<GetDanfePackingLabelInput>(
      `${this.baseUrlSislogApi}/v2/danfe-packing-label/file`,
      input
    ).then(result => {
      this.report.download(result, `${strings.LabelsOfPackingDanfe}.zpl`);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
    });
  }

  pdfHandle = (input: GetDanfePackingLabelInput) => {
    this.http.postToDownloadFile<GetDanfePackingLabelInput>(
      `${this.baseUrlSislogApi}/v2/danfe-packing-label/pdf`,
      input
    ).then(result => {
      this.report.openPdf(result);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
    });
  }

  dataHandle = (input: GetDanfePackingLabelInput): Promise<Result<DanfePackingData[]> | null> => {
    const promise = this.http.post<Result<DanfePackingData[]>, GetDanfePackingLabelInput>(`${this.baseUrlSislogApi}/v2/danfe-packing-label/data`, input);
    return promise;
  }
}